import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../Logo'
import './header.css'

const Index = () => {
    return (
        <>
            {/* <Navbar fixed="top" collapseOnSelect expand="lg" className="bg-body-tertiary" > */}
            <Navbar fixed="top" collapseOnSelect expand="lg" className="bg-body-tertiary" >
                <Container>
                    <Navbar.Brand href="#home"><Logo /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link href="#features">HOME</Nav.Link>
                            <Nav.Link href="#pricing">ABOUT</Nav.Link>
                            <Nav.Link href="#pricing">FAQ's</Nav.Link>
                            <Nav.Link href="#pricing">NEWS</Nav.Link>
                        </Nav>
                        <Nav>
                            <Nav.Link href="#deets" className='nav-button'>CONTACT US</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}

export default Index
